import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SocialFeed from 'Components/SocialFeed';

const ImageWithCommentsDialog = ({
  open,
  onClose,
  imageUrl,
  imageName,
  submissionId,
  submissionDetailId,
  posts,
  isReadOnly,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent sx={theme => ({ p: 0, position: 'relative', bgcolor: theme.palette.background.paper })}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2, bgcolor: 'rgba(0,0,0,0.45)', color: '#fff' }}>
          <CloseIcon />
        </IconButton>

        {imageUrl ? (
          <Box component="img" src={imageUrl} alt={imageName || 'preview'} sx={{ width: '100%', display: 'block' }} />
        ) : null}

        <Box sx={{ p: { xs: 2, md: 3 } }}>
          {imageName ? (
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
              {imageName}
            </Typography>
          ) : null}

          <Divider sx={{ mb: 2 }} />

          <SocialFeed
            submissionId={submissionId}
            submissionDetailId={submissionDetailId}
            posts={posts || []}
            isLoading={false}
            isReadOnly={isReadOnly}
          />

          <DialogActions sx={{ justifyContent: 'flex-end', gap: 1, px: 0, mt: 2 }}>
            <Button onClick={onClose}>{'Close'}</Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

ImageWithCommentsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string,
  imageName: PropTypes.string,
  submissionId: PropTypes.string,
  submissionDetailId: PropTypes.string,
  posts: PropTypes.array,
  isReadOnly: PropTypes.bool,
};

export default ImageWithCommentsDialog;
